var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticStyle: { width: "100%" } }, [
    !_vm.isEditing
      ? _c("div", { staticClass: "ck-view-wrapper" }, [
          _c("div", { staticClass: "ck-edit-bar" }, [
            _c(
              "button",
              {
                staticClass: "ck-edit-btn",
                attrs: { title: "עריכה" },
                on: {
                  click: function ($event) {
                    _vm.isEditing = true
                  },
                },
              },
              [
                _c("b-icon", {
                  attrs: { pack: "fa", icon: "pen", size: "is-small" },
                }),
                _c("span", [_vm._v("עריכה")]),
              ],
              1
            ),
          ]),
          _c("div", {
            staticClass: "ck-view-content",
            domProps: {
              innerHTML: _vm._s(_vm.ckEditorContent || _vm.placeholder),
            },
          }),
        ])
      : _c(
          "div",
          { staticClass: "ck-editor-wrapper", style: _vm.wrapperStyle },
          [
            _c("div", { staticClass: "ck-edit-bar" }, [
              _c(
                "button",
                {
                  staticClass: "ck-edit-btn ck-edit-btn--active",
                  attrs: { title: "סיום עריכה" },
                  on: {
                    click: function ($event) {
                      _vm.isEditing = false
                    },
                  },
                },
                [
                  _c("b-icon", {
                    attrs: { pack: "fa", icon: "pen", size: "is-small" },
                  }),
                  _c("span", [_vm._v("סיום עריכה")]),
                ],
                1
              ),
            ]),
            _c("ckeditor", {
              attrs: { editor: _vm.ckEditor, config: _vm.ckEditorConfig },
              on: { ready: _vm.onEditorReady },
              model: {
                value: _vm.ckEditorContent,
                callback: function ($$v) {
                  _vm.ckEditorContent = $$v
                },
                expression: "ckEditorContent",
              },
            }),
            _c("div", { staticClass: "ck-word-count-bar" }, [
              _c("span", [
                _vm._v("מילים: " + _vm._s(_vm.wordCountStats.words)),
              ]),
              _c("span", [
                _vm._v("תווים: " + _vm._s(_vm.wordCountStats.characters)),
              ]),
            ]),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }